import { inject, Injectable } from "@angular/core";
import { BaseHttpService } from "../../services/common/base.http.service";
import { SearchParameters } from "../../shared/models/searchParameters.model";
import { HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { PagedResult } from "../../shared/models/pagedResult.model";
import { administrationConst } from "../administration.const";
import { SearchRequestTypesChangesModel } from "../models/search-request-type-change.model";
import { RequestTypeChangesModel } from "../models/request-type-changes.model";
import { IRequestAndLineType } from "../models/request-line-types.model";
import { SearchLineTypesChangesModel } from "../models/search-line-type-changes.model";
import { LineTypeChange } from "../models/line-type-changes.model";
import { ILineType } from "../models/line-type.model";
import { RequestType } from "../models/request-type.model";
import { ResultInfo } from "../../shared/models/result-info.model";
import { LineTypeAccount } from "../models/line-type-account.model";
import { ManageLineTypeModel } from "../models/manage-line-type.model";

@Injectable({
  providedIn: 'root'
})
export class RequestAndLineTypeService {
  baseHttpService = inject(BaseHttpService);
  userEmail: string;
    
  searchRequestTypesChanges(searchParameters: SearchParameters<SearchRequestTypesChangesModel>): Observable<PagedResult<RequestTypeChangesModel[]>> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.baseHttpService.post<PagedResult<RequestTypeChangesModel[]>>(administrationConst.requestTypesChanges, searchParameters, { headers: headers });
  }

  searchLineTypesChanges(searchParameters: SearchParameters<SearchLineTypesChangesModel>): Observable<PagedResult<LineTypeChange[]>> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.baseHttpService.post<PagedResult<LineTypeChange[]>>(administrationConst.lineTypeChanges, searchParameters, { headers: headers });
  }

  getRequestLineTypes(): Observable<IRequestAndLineType[]> {
    return this.baseHttpService.get<IRequestAndLineType[]>(administrationConst.requestLineTypes);
  }

  getLineTypes(): Observable<ILineType[]> {
    return this.baseHttpService.get<ILineType[]>(administrationConst.lineTypes);
  }

  getRequestType(requestType: string): Observable<RequestType> {
    return this.baseHttpService.get<RequestType>(administrationConst.requestType + requestType);
  }

  updateRequestType(requestType: RequestType): Observable<ResultInfo> {
    return this.baseHttpService.put<ResultInfo>(administrationConst.requestType, requestType);
  }

  addRequestType(requestType: RequestType): Observable<ResultInfo> {
    return this.baseHttpService.post<ResultInfo>(administrationConst.requestType, requestType);
  }

  deleteRequestType(requestType: string): Observable<ResultInfo> {
    return this.baseHttpService.delete<ResultInfo>(administrationConst.requestType + requestType);
  }

  checkIfExistForGivenRequestType(requestType: string): Observable<boolean> {
    return this.baseHttpService.get<boolean>(administrationConst.imprestVendorsCheck + requestType);
  }

  getLineType(lineType: string): Observable<ILineType> {
    let params = new HttpParams();        
    params = params.set('lineType', lineType);
    return this.baseHttpService.get<ILineType>(administrationConst.lineType, { params });
  }

  getLineTypeByRequest(requestType: string): Observable<ILineType[]> {
    let params = new HttpParams();        
    params = params.set('requestType', requestType);
    return this.baseHttpService.get<ILineType[]>(administrationConst.lineTypeByRequest, { params });
  }

  getLineTypeAccounts(requestType: string, lineType: string): Observable<LineTypeAccount[]> {
    let params = new HttpParams();        
    params = params.set('requestType', requestType);
    params = params.set('lineType', lineType);
    return this.baseHttpService.get<LineTypeAccount[]>(administrationConst.lineTypeAccount, { params });
  }

  updateLineType(manageLineTypeModel: ManageLineTypeModel): Observable<ResultInfo> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.baseHttpService.put<ResultInfo>(administrationConst.lineType, manageLineTypeModel, { headers: headers });
  }

  addLineType(manageLineTypeModel: ManageLineTypeModel): Observable<ResultInfo> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.baseHttpService.post<ResultInfo>(administrationConst.lineType, manageLineTypeModel, { headers: headers });
  }

  deleteLineType(requestType: string, lineType: string): Observable<ResultInfo> {
    let params = new HttpParams();        
    params = params.set('requestType', requestType);
    params = params.set('lineType', lineType);
    return this.baseHttpService.delete<ResultInfo>(administrationConst.lineType, { params });
  }

}